import styled from "styled-components";

const ActivityName = styled.h1`
  margin: 0;
  line-height: 1.25;
  height: calc(1rem * 1.25 * 2);
  color: #484848;
  font-size: 1rem;
  font-weight: 500;
  max-height: calc(1rem * 1.25 * 2);
  overflow: hidden;
  text-overflow: ellipsis;
`;
export default ActivityName;
